<template>
  <el-dialog
    :model-value="modelValue"
    width="420px"
    class="login-dialog"
    modal-class="login-overlay"
    :close-on-click-modal="false"
    append-to-body
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #header>
      <div class="login-head">
        <span class="eyebrow">Secure Access</span>
        <strong>{{ authMode === 'login' ? '探索者登录' : '注册探索者' }}</strong>
        <p>进入层级网络后可占领、收藏、留言与编辑自己的层级档案。</p>
      </div>
    </template>

    <div class="auth-switch">
      <button type="button" class="auth-tab" :class="{ active: authMode === 'login' }" @click="$emit('update:authMode', 'login')">登录</button>
      <button type="button" class="auth-tab" :class="{ active: authMode === 'register' }" @click="$emit('update:authMode', 'register')">注册</button>
    </div>

    <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" label-position="top" @keyup.enter="validateAndSubmit">
      <el-form-item label="账号" prop="username">
        <el-input :model-value="loginForm.username" placeholder="请输入10位账号" maxlength="10" clearable @update:model-value="loginForm.username = String($event)" />
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          :model-value="loginForm.password"
          type="password"
          placeholder="请输入8-20位密码"
          maxlength="20"
          show-password
          clearable
          @update:model-value="loginForm.password = String($event)"
        />
      </el-form-item>
      <el-button class="full-button auth-submit-btn" type="primary" :loading="loading" @click="validateAndSubmit">
        {{ authMode === 'login' ? '登录' : '注册并登录' }}
      </el-button>
    </el-form>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { FormInstance, FormRules } from 'element-plus';

const props = defineProps<{
  modelValue: boolean;
  authMode: 'login' | 'register';
  loginForm: {
    username: string;
    password: string;
  };
  loginRules: FormRules;
  loading: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'update:authMode', value: 'login' | 'register'): void;
  (e: 'submit'): void;
}>();

const loginFormRef = ref<FormInstance>();

const validateAndSubmit = async () => {
  if (!loginFormRef.value) return;
  try {
    await loginFormRef.value.validate();
    emit('submit');
  } catch (error) {
    // Element Plus keeps validation messages visible in the dialog.
  }
};
</script>
